import { render, staticRenderFns } from "./cardJftc.vue?vue&type=template&id=d7f7d3b8&scoped=true&"
import script from "./cardJftc.vue?vue&type=script&lang=js&"
export * from "./cardJftc.vue?vue&type=script&lang=js&"
import style0 from "./cardJftc.vue?vue&type=style&index=0&id=d7f7d3b8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f7d3b8",
  null
  
)

export default component.exports